import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {OAUTH_CONNECT_URL} from "../PanelConstants.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {Flow} from "./Flow.js";


export class OAuthConnectFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.oauthConnect;

    getFlowPlan() {
        return [Flow.auth];
    }

    finalize() {
        Router.changeURL(OAUTH_CONNECT_URL);
    }
}
